import { Button, Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { TableSortLabel } from '@material-ui/core';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import http from "../services/httpService";
import { getDate, searchFilter, handleSort } from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    circle: {

        borderRadius: "100%",
        background: "#3f51b5",
        color: "#fff",
    }
});
const columns = [
    { id: 'UserID', label: 'User ID', minWidth: 170 },
    { id: 'Name', label: 'Name', minWidth: 150 },
    { id: 'DOJ', label: 'Date of Joining', minWidth: 150, format: "Date" },
    { id: 'Expiry', label: 'Pending days to expiry', minWidth: 150 ,format:"number"},
    { id: 'Renewals', label: 'Renewals Done', minWidth: 150,format:"number" },
    { id: 'Referrals', label: 'Referral Done', minWidth: 150 ,format:"number"},
    { id: 'score', label: 'Prospect Satisfaction Score', minWidth: 150,format:"number" },
    // { id: 'lookupparam2', label: 'Portfolio Gains', minWidth: 150,format:"number" },

];
function MyInvestorOverview() {
    let history = useHistory();
    const classes = useStyles();
    const [showWindow, setShowWindow] = useState(true);
    const [overview, setOverview] = useState({});
    const [performance, setPerfromance] = useState({});
    const [activityDetails, setActivityDetails] = useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rows, setRows] = React.useState([]);
    const [searched, setSearched] = React.useState("");
    const [orignalRows, setOriginalRows] = React.useState([])
    const [orderBy, setOrderBy] = React.useState("cust__createddt");
    const [order, setOrder] = React.useState("asc");
    const requestSearch = (searchedVal) => {
        let rowsTemp = [...orignalRows];

        setPage(0);
        setRows(searchFilter(searchedVal, rowsTemp));

    };

    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched);
    };;
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleRequestSort = (e, property, format) => {
        let isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        let tempRows = [...rows]
        let finalRows = handleSort(property, format, tempRows, isAsc)
        
        setRows(finalRows);
        setPage(0);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    useEffect(() => {

        http.get("/client_performance").then(res => {
            if (res && res.data && res.data["Basic details"] && Array.isArray(res.data["Basic details"]) && res.data["Basic details"].length > 0) {
                let details = res.data["Basic details"][0];

                setOverview(details)
            }
            if (res && res.data && res.data["client details"] && Array.isArray(res.data["client details"]) && res.data["client details"].length > 0) {
                let perfromanceDetails = res.data["client details"]
                setOriginalRows(perfromanceDetails)
                setRows(perfromanceDetails)
            }

        }).catch(err => {

        })
    }, [])

    return (<Grid container style={showWindow ? { display: "block" } : { display: "none" }}>


        <Grid container style={{ marginTop: "10px" }} className="overviewbar">
            <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }} >
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack}>Back</Button>
            </Grid>
            <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }} >
                <Typography color="textPrimary" variant="h5" >My Investor List</Typography>
            </Grid>
        </Grid>
        <Grid container style={{ marginTop: "20px", paddingLeft: 30 }} className="prospectgrids">


            <Grid item xs={12} sm={6} md={3} >
                <Typography variant="body1">Average renewal rate</Typography>
                <Typography variant="h6">{overview.avg_renewal_rate}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3} >
                <Typography variant="body1">Attrition rate(Renewals)</Typography>
                <Typography variant="h6">{overview.attrition_rate}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3} >
                <Typography variant="body1">Prospect to investor conversion rate</Typography>
                <Typography variant="h6">{overview.ptoi_conversionrate}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3} >
                <Typography variant="body1">Overall customer satisfaction score</Typography>
                <Typography variant="h6">{"N/A"}</Typography>
            </Grid>
        </Grid>
        <Grid container style={{ marginTop: "20px", paddingLeft: 30 }} className="prospectgrids">

            <Grid item xs={12} sm={6} md={3} >
                <Typography variant="body1">Satisfaction Score</Typography>
                <Typography variant="h6">{"N/A"}</Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3} >
                <Typography variant="body1">Number of renewals done</Typography>
                <Typography variant="h6">{overview.renewed_total}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3} >
                <Typography variant="body1">Referrals received from the clients</Typography>
                <Typography variant="h6">{overview.successful_referrals_total}</Typography>

            </Grid>

        </Grid>

        <Paper className={classes.root}>
            <SearchBar
                value={searched}
                onChange={(searchVal) => requestSearch(searchVal)}
                onCancelSearch={() => cancelSearch()}
                className={"mt30"}
            />
            <TablePagination
                rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={orderBy === column.id ? order : 'asc'}
                                        onClick={e => handleRequestSort(e, column.id, column.format)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={index + "a"}>
                                    {columns.map((column, index) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={index + column.id} align={column.align}>
                                                {column.format && column.format=== 'number' && typeof value === 'number' ?
                                                    Number(value) : (column.format === "Date") ? getDate(value) : value
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>
    </Grid>
    )
}

export default MyInvestorOverview;